import WandSparkles from "./WandSparkles";

export * from "./CirclePlus";
export * from "./Grab";
export * from "./Loader";
export * from "./LoaderCricle";
export * from "./LoaderPinwheel";
export * from "./Pencil";
export * from "./PencilOff";
export * from "./PenTool";
export * from "./Pointer";
export * from "./PointerOff";
export * from "./Sparkles";
export * from "./Stamp";
export * from "./Text";
export * from "./TextCursor";
export * from "./TextSelect";
export * from "./Wand";
export * from "./WandSparkles";

export const Curs = {
  WandSparkles,
};
